export enum FormElementsContentTypes {
  AutoCompleteHiddenElementBlock = "AutoCompleteHiddenElementBlock",
  ChoiceElementBlock = "ChoiceElementBlock",
  DateTimeElementBlock = "DateTimeElementBlock",
  HcaptchaElementBlock = "HcaptchaElementBlock",
  HcaptchaValidElementBlock = "HcaptchaValidElementBlock",
  ItemsSelectionElementBlock = "ItemsSelectionElementBlock",
  NumberElementBlock = "NumberElementBlock",
  SelectionElementBlock = "SelectionElementBlock",
  TextareaElementBlock = "TextareaElementBlock",
  TextareaWithDescriptionElementBlock = "TextareaWithDescriptionElementBlock",
  TextboxElementBlock = "TextboxElementBlock",
  SectionTitleElementBlock = "SectionTitleElementBlock",
  CountryDropdownElementBlock = "CountryDropdownElementBlock",
  StateDropdownElementBlock = "StateDropdownElementBlock",
  ExpandableOptionalTextboxElementBlock = "ExpandableOptionalTextboxElementBlock",
  OverrideRecipientsEmailsElementBlock = "OverrideRecipientsEmailsElementBlock",
  MultiOrSingleChoiceWithDescription = "MultiOrSingleChoiceWithDescription",
}

export enum LabelPlaceholders {
  ItemNumber = "ItemNumber",
}

export enum TextAutoCompleteTypes {
  Email = "email",
  Name = "name",
  FirstName = "given-name",
  LastName = "family-name",
  Organization = "organization",
}

export enum HiddenAutoCompleteTypes {
  CountryCode = 100,
  Currency,
  Email,
  ItemNumber,
  Url,
  Name,
  FamilyPage,
  UserId,
  MailTo,
  DataAreaId,
  ContactUsFormName,
  Details,
  OrderNumber,
}
